<template>
    <div>
        <section>
            <div class="inner row5 mobileCustom">
                <h1 class="boardTitle mobileReset">공지사항</h1>
                <div>
                    <div>
                        <div class="row4">
                            <div class="btnBox blankLeft" v-if="getUser != null && getUser.roleName == 'ROLE_ADMIN'">
                                <button class="blueBtn smBtn" @click="updateNotice">수정</button>
                                <button class="orangeBtn smBtn" @click="deleteBtn">삭제</button>
                            </div>
                            <hr class="hrNotice mobileReset">
                            <div class="noticeWriteContainer">
                                <div class="headTxtContain">
                                    <p>
                                        {{ title }}
                                    </p>
                                </div>
                                <div class="subTxtContain flex">
                                    <p>
                                        <span>
                                            <strong>
                                                작성자
                                            </strong>
                                        </span>
                                        <span>
                                            {{ name }}
                                        </span>
                                    </p>
                                    <p>
                                        <span class="mobileReset">
                                            <strong>
                                                등록일
                                            </strong>
                                        </span>
                                        <span>
                                            {{ regDate }}
                                        </span>
                                    </p>
                                    <p>
                                        <span>
                                            <strong>
                                                조회수
                                            </strong>
                                        </span>
                                        <span>
                                            {{ viewCnt }}
                                        </span>
                                    </p>
                                    <div class="flex flexAlignC mobileInlinBlock">
                                        <p v-for="(file, index) in fileList" :key="index">
                                            <span>첨부파일</span>
                                            
                                            <span class="attechFileImg" @click="fileDownload(file.IDX, file.REAL_FILE_NAME)">
                                                <strong>
                                                    {{ file.REAL_FILE_NAME }}
                                                </strong>
                                                <span v-if="index != Object.keys(fileList).length - 1">, </span>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="textAreaContain">
                                    <div class="noticeTxtBox" v-html="content">
                                    </div>
                                </div>
                                <div class="subBtnContain flex flexAlignS">
                                    <a href="#" @click="golist">목록</a>
                                    <div class="prevNextBtnContain">
                                        <a href="#" @click="goPrevNotice" v-if="prevNotice">이전글</a>
                                        <a href="#" @click="goNextNotice" v-if="nextNotice">다음글</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    </div>   
</template>

<script>
import axios from '@/axios/axios'
import { mapGetters } from 'vuex'
import * as FileUtil from '@/utils/FileUtil'

export default {
    name: 'NoticeDetail',
    data () {
        return {
            listlink: [
                {title:'커뮤니티'},
                {title:'공지사항', link: '/notice', AClass: 'navyC', BClass: 'active'},
                {title:'FAQ', link: '/faq'},
                {title:'1:1 문의', link: '/auth'},
            ],
            idx : this.$route.params.idx,
            title: "",
            content: "",
            name: "",
            regDate: "",
            viewCnt: "",
            fileList: null,
            prevNotice: null,
            nextNotice: null,
            searchText : ''
        }
    },
    computed: {
        ...mapGetters('auth', ['getUser'])
    },
    created() {
        this.detailNoticeInfo();
    },
    watch: {
        '$route': 'detailNoticeInfo'
    },
    methods:{
       goPrevNotice(){
           let idx = this.prevNotice.IDX;
           this.$router.push({ name:'noticeDetail', params: { idx: idx }});
       },
       goNextNotice(){
           let idx = this.nextNotice.IDX;
           this.$router.push({ name:'noticeDetail', params: { idx: idx }});
       },
       golist(){
           this.$router.push({ path : '/notice', query: { searchText : this.searchText }});
       },
       detailNoticeInfo(){
            this.searchText = this.$route.params.searchText;
            let param = {
                IDX : this.$route.params.idx,
                SEARCH_TEXT : this.searchText
            };

            axios.post('/api/notice/getNoticeInfo', param)
            .then(response => {
                if(response.status == 200){
                    let noticeData = response.data.NOTICE;
                    this.title = noticeData.TITLE;
                    this.content = noticeData.CONTENT.replace(/(?:\r\n|\r|\n)/g, '<br />');
                    this.name = noticeData.NAME;
                    this.viewCnt = noticeData.VIEW_CNT;
                    this.regDate = noticeData.REGDATE;
                    this.fileList = noticeData.FILE_LIST;

                    this.prevNotice = response.data.PREV_NOTICE;
                    this.nextNotice = response.data.NEXT_NOTICE;
                }
            })
            .catch(() => {
            })
            .then(() => {
            });
       },
       updateNotice(){
           this.$router.push({ path : '/admin/noticeManagementWrite/'+this.idx });
       },
       deleteBtn(){
           var response = this.$createConfirmResponse()
           this.$confirm("알림", "글을 삭제 하시겠습니까?", "확인", "취소", response, {
                'closed': () => {
                    if(response.result){
                        let paramDatas = { IDX : this.idx };
                        axios.post('/api/admin/notice/delete', paramDatas)
                        .then(result => {
                            if(result.status == 200){
                                this.$alert("알림", `공지사항이 삭제되었습니다.`, "", {
                                    'closed': () => {
                                        this.golist();
                                    }
                                });
                            }
                            else {
                                this.$alert("알림", "공지사항 삭제에 실패하였습니다. 관리자에게 문의해주세요.");
                            }
                        })
                        .catch((error) => {
                            this.$alert("알림", "공지사항 삭제에 실패하였습니다. 관리자에게 문의해주세요.<br>"+  error.response.data.error);
                        });
                    }
                }
            })
        },
        fileDownload(idx, fileName){
            FileUtil.FileDownload('/api/file/fileDownload', idx, fileName);
        }
  }
}

</script>


<style>
    .hrNotice {
        margin: 10px 0 0 0;
    }
</style>

<style scoped lang="css" >
    img {width: 100%; height: auto;}
</style>
